<p-table [value]="venueService.productStatistics.value">
	<ng-template pTemplate="header">
		<tr>
			<th>Date</th>
			<th>Device Type</th>
			<th>Added Item</th>
			<th>Completed Transaction</th>
		</tr>
	</ng-template>
	<ng-template let-rec pTemplate="body">
		<tr (click)="productUseSelected = rec">
			<td>
				{{ app.moment.unix(rec.useDateTime).format("l LT") }}
			</td>
			<td>
				{{ rec.deviceType }}
			</td>
			<td>
				<div *ngIf="rec.cardItemAdded">
					<fa-icon [icon]="['far', 'check']"></fa-icon>
					{{ moment(rec.cartItemAddedDateTime).from(moment.unix(rec.useDateTime)) }}
				</div>
				<fa-icon *ngIf="!rec.cardItemAdded" [icon]="['far', 'times']"></fa-icon>
			</td>
			<td>
				<div *ngIf="rec.transactionComplete">
					<fa-icon [icon]="['far', 'check']"></fa-icon>
					{{ moment.unix(rec.transactionCompleteDateTime).from(moment.unix(rec.useDateTime)) }}
				</div>
				<fa-icon *ngIf="!rec.transactionComplete" [icon]="['far', 'times']"></fa-icon>
			</td>
		</tr>
	</ng-template>
</p-table>
